import { AlertDialog, type DialogProps, XStack, YStack } from "tamagui";
import { hairline } from "../utils/hairline";
import { LoadingButton, TextButton } from "./LoadingButton";
import { appear } from "./Motion/motion";
import { Paragraph, Subheadline2 } from "./Typography";
export type AlertDialogNotificationProps = {
  title: string;
  message: string;
  // defaults to Ok
  acceptText?: string;
  // defaults to Cancel
  cancelText?: string;
  // defaults to true
  native?: boolean;
  // defaults to false
  cancellable?: boolean;
  // defaults to false (if true, the cancel button will be thin)
  cancelThin?: boolean;
  acceptTestID?: string;
  cancelTestID?: string;
  onAccept?: () => void;
  onOpenChange?: (open: boolean) => void;
};

/*
 * Implements a simple native AlertDialog
 * see https://tamagui.dev/docs/components/alert-dialog
 */
export const AlertDialogNotification = ({
  title,
  message,
  acceptText = "Ok",
  native = true,
  open,
  onOpenChange,
  onAccept,
  cancellable = false,
  cancelThin = false,
  acceptTestID,
  cancelTestID
}: AlertDialogNotificationProps & Omit<DialogProps, "onOpenChange">) => {
  return <AlertDialog native={native} open={open} onOpenChange={onOpenChange} data-sentry-element="AlertDialog" data-sentry-component="AlertDialogNotification" data-sentry-source-file="AlertDialogNotification.tsx">
      <AlertDialog.Trigger data-sentry-element="AlertDialog.Trigger" data-sentry-source-file="AlertDialogNotification.tsx" />
      <AlertDialog.Portal data-sentry-element="AlertDialog.Portal" data-sentry-source-file="AlertDialogNotification.tsx">
        <AlertDialog.Overlay key="overlay" transition="fade" opacity={0.5} enterStyle={{
        opacity: 0
      }} exitStyle={{
        opacity: 0
      }} data-sentry-element="AlertDialog.Overlay" data-sentry-source-file="AlertDialogNotification.tsx" />
        <AlertDialog.Content elevate key="content" {...appear("drop")} backgroundColor="$background" borderRadius="$10" borderWidth={hairline} borderColor="$strokeSecondary" data-sentry-element="AlertDialog.Content" data-sentry-source-file="AlertDialogNotification.tsx">
          <YStack px="$6" py="$5" gap="$3" data-sentry-element="YStack" data-sentry-source-file="AlertDialogNotification.tsx">
            <AlertDialog.Title data-sentry-element="AlertDialog.Title" data-sentry-source-file="AlertDialogNotification.tsx">
              <Subheadline2 data-sentry-element="Subheadline2" data-sentry-source-file="AlertDialogNotification.tsx">{title}</Subheadline2>
            </AlertDialog.Title>
            <AlertDialog.Description data-sentry-element="AlertDialog.Description" data-sentry-source-file="AlertDialogNotification.tsx">
              <Paragraph theme="alt1" data-sentry-element="Paragraph" data-sentry-source-file="AlertDialogNotification.tsx">{message}</Paragraph>
            </AlertDialog.Description>
            <XStack gap="$3" justifyContent="flex-end" pt="$2" data-sentry-element="XStack" data-sentry-source-file="AlertDialogNotification.tsx">
              {cancellable ? cancelThin ? <AlertDialog.Action asChild onPress={() => onOpenChange}>
                    <TextButton f={1} testID={cancelTestID}>
                      Cancel
                    </TextButton>
                  </AlertDialog.Action> : <AlertDialog.Cancel asChild>
                    <TextButton f={1} testID={cancelTestID}>
                      Cancel
                    </TextButton>
                  </AlertDialog.Cancel> : null}
              <AlertDialog.Action asChild onPress={onAccept} data-sentry-element="AlertDialog.Action" data-sentry-source-file="AlertDialogNotification.tsx">
                <LoadingButton f={1} // Button needs with even tho flex is applied
              width="100%" testID={acceptTestID} data-sentry-element="LoadingButton" data-sentry-source-file="AlertDialogNotification.tsx">
                  {acceptText}
                </LoadingButton>
              </AlertDialog.Action>
            </XStack>
          </YStack>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog>;
};